import { CompanyType, PointsActionCompleted } from "@t3/shared";
import { IncentivesProgramCard } from "./IncentivesProgramCard";
import { PurchaseRefundCard } from "./PurchaseRefundCard";
import { TaskerRewardCard } from "./TaskerRewardCard";
import { UserTransferCard } from "./UserTransferCard";
import { CodeRedemptionCard } from "./CodeRedemptionCard";

interface TransactionCardProps {
  action: PointsActionCompleted;
  company: CompanyType | null;
}

export const TransactionCard = ({ action, company }: TransactionCardProps) => {
  const createdAt = action.createdAt.toFormat("MMMM d, yyyy");

  if (action.type === "incentivesProgramAward") {
    return (
      <IncentivesProgramCard
        action={action}
        company={company}
        createdAt={createdAt}
      />
    );
  }

  if (action.type === "purchase" || action.type === "refund") {
    return <PurchaseRefundCard action={action} createdAt={createdAt} />;
  }

  if (action.type === "taskerReward") {
    return <TaskerRewardCard action={action} createdAt={createdAt} />;
  }
  if (action.type === "userTransfer") {
    return <UserTransferCard action={action} createdAt={createdAt} />;
  }
  if (action.type === "codeRedemption") {
    return <CodeRedemptionCard action={action} createdAt={createdAt} />;
  }
};
